export const convertToValidID=text=>{return text.toLowerCase().replace(/^[^a-z]+|[^\w:.-]+/gi,'');};